export default {
  header: {
    title: 'Brug dine point',
    balance: '{{value}} point tilgængelige',
  },
  option_label: '{{value}} point',
  buttons: {
    none: 'Ingen',
  },
  toasts: {
    enabled: 'Loyalitetspoint er anvendt',
    removed: 'Loyalitetspoint er fjernet',
  },
};
